export default __webpack_public_path__ + "static/media/logoAlizeWhite.b7cf2cc2.svg";